import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/Index'
import Order from '@/pages/Order'
import OrderDetail from '@/pages/OrderDetail'
import Favorite from '@/pages/Favorite'
import Point from '@/pages/Point'
import Gain from '@/pages/Gain'
import Address from '@/pages/Address'
import Info from '@/pages/Info'
import Pay from '@/pages/Pay'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', name: 'index', component: Index },
    { path: '/order', name: 'order', component: Order },
    { path: '/order/:id', name: 'orderDetail', component: OrderDetail },
    { path: '/favorite', name: 'favorite', component: Favorite },
    { path: '/point', name: 'point', component: Point },
    { path: '/gain', name: 'gain', component: Gain },
    { path: '/address', name: 'address', component: Address },
    { path: '/info', name: 'info', component: Info },
    { path: '/pay', name: 'pay', component: Pay }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js